import GlobalAxios from "../axios/axios-config";
import TemporaryAxios from "../axios/temprary-axios-config";
import {
  IInternalProcedure,
  IInternalProcedureParams,
} from "../models/internal-procedure";

const INTERNAL_PROCEDURE_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/InternalProcedure/InternalProcedure";

const INTERNAL_PROCEDURE_TASY_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/InternalProcedure/Tasy";

export const getInternalProcedures = (params?: IInternalProcedureParams) => {
  return GlobalAxios.get<IInternalProcedure[]>(INTERNAL_PROCEDURE_ROUTE, {
    params,
  });
};

export const getTasyInternalProcedures = (
  params?: IInternalProcedureParams
) => {
  return TemporaryAxios.get<IInternalProcedure[]>(
    INTERNAL_PROCEDURE_TASY_ROUTE,
    {
      params,
    }
  );
};
